import { ROUTE_PREFIXES } from '@/common/constants/route-prefixes';

const A = ROUTE_PREFIXES.admin;

/** Route patterns for router config (relative segments) */
export const adminRoutePatterns = {
  dashboard: 'dashboard',
  evaluations: 'evaluations',
  moduleDetails: 'evaluations/modules/:moduleId',
  medias: 'medias',
  articles: 'medias/articles',
  videos: 'medias/videos',
  trainings: 'medias/trainings',
  agents: 'agents',
  users: 'users',
  userDetails: 'users/:userId',
  institutions: 'institutions',
  institutionDetails: 'institutions/:institutionId',
  subscriptions: 'subscriptions',
  sensoquizz: 'sensoquizz',
  notifications: 'notifications',
  mobileApp: 'mobile-app',
  changelog: 'changelog',
} as const;

/** Full paths for navigation (navigate, Link) */
export const adminRoutes = {
  dashboard: `${A}/dashboard`,
  users: `${A}/users`,
  userDetails: (id: string) => `${A}/users/${id}`,
  institutions: `${A}/institutions`,
  institutionDetails: (id: string) => `${A}/institutions/${id}`,
  sensoquizz: `${A}/sensoquizz`,
  evaluations: `${A}/evaluations`,
  moduleDetails: (id: string) => `${A}/evaluations/modules/${id}`,
  medias: `${A}/medias`,
  articles: `${A}/medias/articles`,
  videos: `${A}/medias/videos`,
  trainings: `${A}/medias/trainings`,
  agents: `${A}/agents`,
  subscriptions: `${A}/subscriptions`,
  notifications: `${A}/notifications`,
  mobileApp: `${A}/mobile-app`,
  changelog: `${A}/changelog`,
} as const;
